import { Link } from 'react-router-dom';
import type { FormEvent, ReactNode } from 'react';

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="auth-shell" data-testid="auth-shell">
      <div className="auth-shell__panel">
        <Link to="/login" className="auth-shell__brand" aria-label="Spox">
          <img
            src="/brand/logo/horizontal/full-colour/spox-horizontal-transparent.png"
            alt="Spox"
            width={160}
            height={40}
          />
        </Link>
        <h1>{title}</h1>
        {subtitle ? <p className="muted">{subtitle}</p> : null}
        {children}
      </div>
    </div>
  );
}

export function AuthForm({
  onSubmit,
  children,
  error,
  submitLabel,
  busy,
}: {
  onSubmit: (event: FormEvent) => void;
  children: ReactNode;
  error: string | null;
  submitLabel: string;
  busy?: boolean;
}) {
  return (
    <form className="auth-form stack" onSubmit={onSubmit}>
      {children}
      {error ? <p className="error">{error}</p> : null}
      <button className="btn" type="submit" disabled={busy}>
        {busy ? 'Please wait…' : submitLabel}
      </button>
    </form>
  );
}
